export enum CurrentType {
    ADD,
    EDIT,
    ADD_FROM_QUOTES
  }